module.exports = __webpack_public_path__ + "img/自定义分享.e3c34511.gif";